import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import ReactMarkdown from "react-markdown";
import { addDisplayName } from "../Infra/display-name";
import { AnchorBlue, MarkdownContainer, MarkdownText } from "./HXMobilePage.styles";
import { sanitizeMarkdownHref } from "./markdownSafeHref";
export const MarkdownBlock = (props) => {
    const { markdown, Paragraph = MarkdownText, paragraphPreWrap } = props;
    const components = React.useMemo(() => ({
        p: ({ children }) => _jsx(Paragraph, { ...(paragraphPreWrap ? { preWrap: true } : {}), children: children }),
        a: ({ href, children, className, title, node: _node }) => {
            const safe = sanitizeMarkdownHref(href);
            if (!safe)
                return (_jsx("span", { className: className, title: title, children: children }));
            return (_jsx(AnchorBlue, { className: className, title: title, href: safe, underline: true, target: "_blank", rel: "noopener noreferrer", children: children }));
        },
    }), [Paragraph, paragraphPreWrap]);
    return (_jsx(MarkdownContainer, { children: _jsx(ReactMarkdown, { components: components, children: markdown }) }));
};
addDisplayName(MarkdownBlock, "MarkdownBlock");
